import { Features } from "@/components/marketing/Features"
import { HeroSection } from "@/components/marketing/HeroSection"
import { Methodology } from "@/components/marketing/Methodology"
import { SEO } from "@/components/SEO"
import { generateWebsiteSchema, generateOrganizationSchema } from "@/lib/jsonLd"

export default function Home() {
  const websiteSchema = generateWebsiteSchema({
    name: "WithWords",
    url: "https://www.withwords.app",
    description: "Master Semantic SEO & Topical Authority with WithWords. Learn advanced SEO techniques using contextual vectors, semantic content networks, and topical maps."
  })

  const organizationSchema = generateOrganizationSchema({
    name: "WithWords",
    url: "https://www.withwords.app",
    logo: "https://www.withwords.app/images/logo.png",
    description: "WithWords helps content creators master semantic SEO and build topical authority without relying on backlinks.",
    socialProfiles: [
      "https://twitter.com/withwordsai",
      "https://www.linkedin.com/company/withwords"
    ]
  })

  return (
    <>
      <SEO
        title="Master Semantic SEO & Topical Authority | WithWords"
        description="Learn advanced SEO techniques using contextual vectors, semantic content networks, and topical maps to dominate search rankings without relying on backlinks."
        schema={[websiteSchema, organizationSchema]}
      />
      <main className="min-h-screen bg-gradient-to-br from-background to-background/90">
        <HeroSection />
        <Features />
        <Methodology />
      </main>
    </>
  )
}